// removed by extract-text-webpack-plugin
module.exports = {"borderRadius":"4px","unit":"5px","colorPrimaryOrange":"#e16e46","shadeDisabled":"rgb(205, 204, 204)","colorBackground":"rgb(245, 244, 243)","shadeMedium":"rgb(142, 141, 142)","colorWhite":"#ffffff","bold":"fonts__bold____2QXwg","colorBoxShadowDark":"rgba(49, 47, 48, 0.15)","colorBoxShadowLight":"rgba(49, 47, 48, 0.05)","page":"details-view__page____33qC6","body":"details-view__body____3znpx","row":"details-view__row____J667R","box":"details-view__box____3tRI6","select":"details-view__select____2xGDL","buttonList":"details-view__buttonList____1PGr7","detailWithList":"details-view__detailWithList____22rDR"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/common/details-view.css
// module id = 40
// module chunks = 0